<template>
  <v-row 
    justify="center" v-show="mainDialog"
      @click="handleHide"
    >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @click="handleHide"
    >
      <custom-carousel 
        v-if="contents"
        :onClick="handleHide"
        :contents="contents"
        :dialog="dialog"
      />
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
import api from '@/services/api'
import utils from '@/services/utils'
import CustomCarousel from './CustomCarousel'
export default {
  components: {
    CustomCarousel,
  },
  data: () => ({
    timer: null,
    timerExit: null,
    mainDialog: false,
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false,
    screensaverImages: null,
    isScreensaver: false,
    defaultDelay: 300000,
    delayInMilliseconds: 300000,
    defaultDelayExitScreensaverTime: 300000,
    delayExitScreensaverTime: 300000,
    
    contents: null,
  }),
  computed: {
    urlDomain () {
      return utils.getDomain()
    },
    screensaverTime () {
      return this.$route.query.screensaverTime ? this.$route.query.screensaverTime | 0 : null
    },
  },
  mounted () {
    if (this.screensaverTime) {
      this.defaultDelay = this.screensaverTime
      this.delayInMilliseconds = this.screensaverTime
    }
    //if (!this.isScreensaver) return
    const that = this
    document.onclick = (event) => {
      // Compensate for IE<9's non-standard event model
      if (event === undefined) event= window.event
      var target= 'target' in event? event.target : event.srcElement
      that.updateDelay(target)
    }
    this.updateDelay()
  },
  methods: {
    updateDelay (target) {
      this.prepareDelay()
    },
    prepareMediaContent (type, url, duration) {
      if (!duration || duration.length === 0) duration = 1
      const content = type === 'mp4' ? `<video src="${url}" width="100%" height="100%" loop
            autoplay="autoplay" muted defaultmuted playsinline />`
        : `<img src="${url}" width="100%" height="100%">`
      return {
        content,
        duration,
        type
      }
        //return `<v-img src="${url}" height="607px" width="100%" />`
    },
    handleGetImages () {
      api.getItem('enterprises', false, `screensaver-totem/${this.urlDomain}`)
        .then(response => {
          const url = response && response.TotemScreenSaver && response.TotemScreenSaver.length > 0 ? response.TotemScreenSaver : null
          this.isScreensaver = url ? true : false
          if (this.isScreensaver) {
            this.delayInMilliseconds = this.defaultDelay
            axios.get(url)
              .then (response => {
                try {
                  const that = this
                  parseString (response.data, (err, results) => {
                  // parsing to json
                    /*
                    that.screensaverImages = null
                    that.screensaverImages = results.rss.channel.shift().item.map(item => {
                      const { url, type, duration } = item['media:content'].shift()['$']
                      return that.prepareMediaContent(type, url, duration)
                      //return item['media:content'].shift()['$'].url
                    })//.filter(x => x.indexOf('.mp4') === -1)
                    */

                    that.contents = []
                    let totalDuration = 0
                    that.contents = results.rss.channel.shift().item.map(item => {
                      const { url, type, duration } = item['media:content'].shift()['$']
                      totalDuration += duration | 0
                      return that.prepareMediaContent(type, url, duration)
                    })
                    // if totalDuration > 5min then totalDuration else defaultExitTime (5min)
                    this.delayExitScreensaverTime = totalDuration && totalDuration > 0 && totalDuration > 300 ? totalDuration * 1000 : this.defaultDelayExitScreensaverTime

                    if (that.contents && that.contents.length > 0) {
                    //if (that.screensaverImages && that.screensaverImages.length > 0) {
                      console.log('contents', that.contents)
                      this.prepareExitDelay()
                      this.mainDialog = true
                      this.dialog = true
                    } else {
                      this.prepareDelay()
                    }
                    //console.log('hh', that.screensaverImages)
                  })
                } catch (error) {
                  console.log(error)
                  this.prepareDelay()
                }
              })
          } else {
            this.screensaverImages = null
            this.contents = []
            this.delayInMilliseconds = 1800000
            this.prepareDelay()
          }
        })
    },
    prepareExitDelay () {
      if (this.timerExit) clearTimeout(this.timerExit)
      this.timerExit = setTimeout(() => {
        this.dialog = false
        this.mainDialog = false
        this.prepareDelay()
      }, this.delayExitScreensaverTime)
    },
    prepareDelay () {
      //const delayInMilliseconds = 5000
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleGetImages()
      }, this.delayInMilliseconds)
    },
    handleHide () {
      this.dialog = false
      this.mainDialog = false
      this.prepareDelay()
    },
  },
}
</script>
